import React, { useState } from 'react'
import { Modal, Row, Col, FormControl, FormLabel } from 'react-bootstrap'
import Button from 'react-bootstrap-button-loader'
import * as ajax from '../Utilities/ajax'
import { BiPlusMedical } from "react-icons/bi";
import { AiOutlineDelete } from "react-icons/ai";
import { IconButton, Tooltip } from '@material-ui/core'
import { Alert } from '@material-ui/lab';
import { BsArrowDown, BsArrowUp } from 'react-icons/bs';
import Auth from '../Utilities/Auth';

export default function SectionOrTag(props) {

  const [option, setOption] = useState(props.val)
  const [newValue, setNewValue] = useState(undefined)
  const [loading, setLoading] = useState(false)
  const [loadingA, setLoadingA] = useState(false)

  const handleTags = (label) => {
    let newOptions = []
    newOptions = option.filter(v => v.label !== label)
    setOption(newOptions)
  }

  const handleLoading = async () => {
    const ticket = newData()
    setLoadingA(true)
    await ticket
    setLoadingA(false)
  }

  const newData = async () => {
    let _newValue = {
      label: newValue,
      value: newValue,
      id: undefined 
    }
    if (props.open.key==="Section") {
      const {data} =  await ajax.post('/video/createSection', {sectionName: newValue}).then(result => result.data).catch(err => err)
      if (data.id) _newValue.id = data.id
    }
    option.push(_newValue)
    const options = option
    setOption(options)
  }

  const handleForm = (event) => {
    setNewValue(event.target.value)
  }
  const handleSortOder = async (id, key, section_order) => {
    setLoading(true)
    await ajax.post(`/video/sort/section`, {id, key, section_order}).then(res => res.data).catch(err => console.log(err))
    const sortSection = await ajax.get(`/video/sections`).then(res => res.data).catch(err => console.log(err))
    setOption(sortSection)
    setLoading(false)
  }

  const handleConfirm = async () => {
    setLoading(true)
    let options = option
    await ajax.post(`/video/handle${props.open.key}?user=${Auth.getUserName()}`, options).then(res => res.data).catch(err => console.log(err))
    setLoading(false)
    props.callback(props.open.key, props.open.page, props.open.value)
  }

  return (
    <Modal show={props.open.show} size={props.open.key!=="Section" ? null :"lg"}>
      <Modal.Header>
        <Modal.Title>{ "Edit " + props.open.key }</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!loadingA ? (option || []).map((v, i) => (
          <Row key={i} style={{ marginTop: '6px' }}>
          <Col xs={props.open.key!=="Section" ? 10 : 9} >
            <Alert variant="outlined" severity="success" color="info">
              {v.value}
            </Alert>
          </Col>
          {props.open.key==="Section" ? <Col xs={3}>
            <Row>
            <Col xs={4} style={{paddingLeft: 0}} >
            <Tooltip title={"Sort up " + props.open.key} aria-label="Sort up">
              <IconButton aria-label="sort up" disabled={loading} onClick={() => handleSortOder(v.id, "Up", i+1)}>
                <BsArrowUp  />
              </IconButton>
            </Tooltip>
            </Col>
            <Col xs={4} style={{paddingLeft: 0}} >
            <Tooltip title={"Sort down " + props.open.key} aria-label="Sort down">
              <IconButton aria-label="sort down" disabled={loading} onClick={() => handleSortOder(v.id, "Down", i+1)}>
                <BsArrowDown />
              </IconButton>
            </Tooltip>
            </Col>
            <Col xs={4} style={{paddingLeft: 0}} >
            <Tooltip title={"Delete " + props.open.key} aria-label="delete">
              <IconButton aria-label="delete" disabled={loading} onClick={() => handleTags(v.label)}>
                <AiOutlineDelete style={{color: "red"}} />
              </IconButton>
            </Tooltip>
            </Col>
            </Row>
          </Col> : <Col xs={2}>
            <Tooltip title={"Delete " + props.open.key} aria-label="delete">
              <IconButton aria-label="delete" onClick={() => handleTags(v.label)}>
                <AiOutlineDelete style={{color: "red"}} />
              </IconButton>
            </Tooltip>
            </Col>}
        </Row>
        )): "test"}
        <Row>
          <Col xs={4} sm={3}><FormLabel className="labelTextSection">{"New " + props.open.key + "s"}</FormLabel></Col>
          <Col xs={6} sm={7} style={{ marginTop: '6px' }} >
            <FormControl type="text" name="new" placeholder={"New " + props.open.key} onChange={handleForm} />
          </Col>
          <Col xs={2} sm={2} style={{display: "flex", alignItems: "center", justifyContent: "center", padding: 0}} >
            <Tooltip title="Edit Tag" aria-label="add">
              <IconButton aria-label="delete" onClick={handleLoading}>
                <BiPlusMedical style={{ marginTop: "3px" ,fontSize: "24px", cursor: "pointer" }}  />
              </IconButton>
            </Tooltip>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button bsStyle="primary"
          loading={loading}
          onClick={handleConfirm}
        >
          {loading ? 'Please wait' : 'Save'}
        </Button>
        <Button bsStyle="default" onClick={() => props.callback(undefined, props.open.page, props.open.value)}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  )
}
